module.exports = __webpack_public_path__ + "static/media/Slide63.1ca4f021.JPG";